module.exports = __webpack_public_path__ + "img/52.8.TSS.da4f9742.png";